import { render, staticRenderFns } from "./KPICard.vue?vue&type=template&id=1d8c2e02&scoped=true"
import script from "./KPICard.vue?vue&type=script&lang=js"
export * from "./KPICard.vue?vue&type=script&lang=js"
import style0 from "./KPICard.vue?vue&type=style&index=0&id=1d8c2e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c2e02",
  null
  
)

export default component.exports